import { render, staticRenderFns } from "./template-designer.vue?vue&type=template&id=3162b41a&scoped=true&"
import script from "./template-designer.vue?vue&type=script&lang=js&"
export * from "./template-designer.vue?vue&type=script&lang=js&"
import style0 from "./template-designer.vue?vue&type=style&index=0&id=3162b41a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3162b41a",
  null
  
)

export default component.exports